export default __webpack_public_path__ + "static/media/studentPlaceholder.adaec705.svg";